export default __webpack_public_path__ + "static/media/Group 485.fcf061d2.png";